export default __webpack_public_path__ + "static/media/ratingbanner.5a6906f0.jpg";